import { createStore, applyMiddleware, compose } from 'redux'
import {
  routerMiddleware,
  routerActions,
  connectRouter,
} from 'connected-react-router'
import thunk from 'redux-thunk'
import { createBrowserHistory } from 'history'
import { createLogger } from 'redux-logger'
import rootReducer from 'reducers'

export const history = createBrowserHistory()

const enhancers = []
const middleware = [thunk, routerMiddleware(history)]

const logger = createLogger({
  level: 'info',
  collapsed: true,
})

if (process.env.NODE_ENV !== 'test') {
  middleware.push(logger)
}

const actionCreators = {
  ...routerActions,
}

const composeEnhancers =
  process.env.NODE_ENV !== 'production' &&
  typeof window === 'object' &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        actionCreators,
      })
    : compose

const composedEnhancers = composeEnhancers(
  applyMiddleware(...middleware),
  ...enhancers
)

export const configureStore = (initialState = {}) => {
  const store = createStore(
    connectRouter(history)(rootReducer),
    initialState,
    composedEnhancers
  )

  if (process.env.NODE_ENV !== 'production') {
    if (module.hot) {
      module.hot.accept('reducers', () => {
        store.replaceReducer(rootReducer)
      })
    }
  }

  return store
}
